import styled, {css} from "styled-components"

import {SpacingProps, spacingCss} from "../global/css"
import {extraSmallStyles, smallStyles, regularStyles, mediumStyles, largeStyles, mainStyles} from "./styles"

export interface BrandAvatarProps extends SpacingProps {
  extraSmall?: boolean,
  small?: boolean,
  regular?: boolean,
  medium?: boolean,
  large?: boolean,
  withShadow?: boolean
}

export default styled.img<BrandAvatarProps>`
  ${mainStyles}

  ${({extraSmall}) => extraSmall && extraSmallStyles}
  ${({small}) => small && smallStyles}
  ${({regular}) => regular && regularStyles}
  ${({medium}) => medium && mediumStyles}
  ${({large}) => large && largeStyles}

  /* calculate size responsively if not specified */

  ${({extraSmall, small, regular, medium, large, theme}) =>
    !extraSmall &&
    !small &&
    !regular &&
    !medium &&
    !large &&
    css`
      ${smallStyles}

      ${theme.mediaQueries.minWidthMedia.tablet`
        ${largeStyles}
      `}
    `}

  ${({withShadow, theme}) => withShadow && `box-shadow: ${theme.shadows.mid};`}

  ${spacingCss}
`
